import styled from 'styled-components';
import { contentCentered } from 'helpers/styles.js';

export const StyledSplitModalCol = styled.div`
  width: 50%;
  height: 100%;
  display: inline-block;
  position: relative;
`;

export const StyledSplitModalWrapper = styled.div`
  height: 100%;
  border-radius: 20px;
  width: 100%;
  margin: auto;
  overflow: hidden;

  ${StyledSplitModalCol}{
    &:nth-child(1) {
      ${contentCentered};
      vertical-align: top;
      background-color: #fff;
    }
    &:nth-child(2) {
      background-color: #2B4F70;
    }
  }
`;

export const StyledModalImage = styled.div`
  background-image: ${({ imgUrl }) => `url('${imgUrl}')`};
  background-size: ${({ imageSize }) => imageSize ? `${imageSize}` : 'contain'};
  background-position: ${({ imagePosition }) => imagePosition ? `${imagePosition}` : 'center'};
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
`;

export const StyledInfoContainer = styled.div`
  width: 80%;
  max-width: 329px;
  text-align: left;
`;

export const StyledModalTitle = styled.div`
  font-weight: 500;
  font-size: 9px;
  line-height: 13px;
  color: ${({ theme }) => theme.colors.palette[6]};
  text-transform: uppercase;
  margin-bottom: 12px;
  letter-spacing: 2px;
`;

export const StyledContentTitle = styled.div`
  font-weight: 300;
  font-size: 30px;
  line-height: 43px;
  color: ${({ theme }) => theme.colors.palette[7]};
  margin-bottom: 26px;
`;

export const StyledContentContainer = styled.div`
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 26px;
`;

export const StyledButton = styled.div`
  min-width: 78px;
  height: 30px;
  display: inline-block;
  cursor: pointer;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 1px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 9px 14px;
  border-radius: 20px;
  position: relative;
  line-height: 13px;
  font-size: 9px;
  color: #fff;
  background-color: ${({ theme }) => theme.colors.palette[7]};
`;
